import { BaseSurvey } from '../base-survey';
import { validateESCTriggerCondition } from '../utils';
import { ESCWebUIAutomatedDeletionSurveyView } from './view';

export class EscWebuiAutomatedAdDeletionSurvey extends BaseSurvey {
  getSurveyName = () => 'EscWebuiAutomatedAdDeletionSurvey';

  getSurveyId = () => 'e6579f37-b3f8-41d8-9aa4-63b6f875c9f3';

  validateTriggerCondition = () => validateESCTriggerCondition(this, 'ESCAutomatedAdDeletion');

  onSurveySubmit = () => {
    window.survey.ESCAutomatedAdDeletion = false;
    delete window.survey.ESCAutomatedAdDeletionCustomParams;
  };

  onSurveyDismiss = () => {
    window.survey.ESCAutomatedAdDeletion = false;
    delete window.survey.ESCAutomatedAdDeletionCustomParams;
  };

  getSurveyComponent = () => ESCWebUIAutomatedDeletionSurveyView;

  getSurveyCustomParams = () => window.survey.ESCAutomatedAdDeletionCustomParams;
}
